import axios from 'axios';
import qs from "qs";

const rootApp = axios.create({
    baseURL: ''
});

const processLogin = ({username, password, api_token}) => rootApp.post('index.php?r=aprendo/processLogin',
    qs.stringify({is_subdomain: window.IS_SUBDOMAIN, domain: window.DOMAIN, password, api_token, username})
);



const getTranslate = ({body}) => rootApp.get('/webroot/translates/'+body.language);
const stayAlive = () => rootApp.get('index.php?r=aprendo/StayAlive');
const doLogout = () => rootApp.get('index.php?r=aprendo/logout');
const AsignPeopleToCourse = ({courseId, body}) => rootApp.post(`index.php?r=people/AsignPeopleToCourse&id=${courseId}`, qs.stringify(body, { arrayFormat: 'brackets' }));
const removeUserFromCourse = ({ body}) => {
    var xsrfMatch = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
    var xsrfToken = xsrfMatch ? xsrfMatch[1] : '';
    xsrfToken = xsrfToken !== '' ? xsrfToken : (typeof XSRF_TOKEN !== 'undefined') ? XSRF_TOKEN : '';
    return rootApp.post(`index.php?r=CoursePeople/RemovePeopleCourse&id=7`, qs.stringify({...body, 'X-XSRF-TOKEN': xsrfToken}));
};
const ListUserCourses = ({userId, body}) => rootApp.post(`index.php?r=report/ListUserCourses/id/${userId}/limit/10&page=1`, qs.stringify(body, { arrayFormat: 'brackets' }));
const listPeople = ({body}) => rootApp.post(`/index.php?r=coursePeopleTeam/ListPeople`, qs.stringify(body, { arrayFormat: 'brackets' }));
const cloneCourse = ({body}) => rootApp.post(`/index.php?r=course/CloneCourse`,  qs.stringify(body));
const deleteCourse = ({body}) => rootApp.post(`/index.php?r=course/deleteCourse`,  qs.stringify(body));
const convertReward = ({body}) => rootApp.post(`/index.php?r=course/CreateAndUpload`,  qs.stringify(body));

const changeLanguage = ({body}) => rootApp.post(`/index.php?r=aprendo/ChangeLanguage`,  qs.stringify(body));


const deleteUser = ({body}) => rootApp.post(`/index.php?r=people/deleteUser`,  qs.stringify(body));

//Log events
const getDomainLogEvents = ({body}) => rootApp.post(`/index.php?r=ApprendoLog/GetData`, qs.stringify(body, { arrayFormat: 'brackets' }));


export default {
    processLogin,
    stayAlive,
    doLogout,
    AsignPeopleToCourse,
    removeUserFromCourse,
    ListUserCourses,
    listPeople,
    cloneCourse,
    deleteCourse,
    convertReward,
    deleteUser,
    getTranslate,
    changeLanguage,
    getDomainLogEvents
};
